module.exports = __webpack_public_path__ + "fonts/Amiri-Regular.a0eaf4f9.ttf";